const SETTINGS_KEY = 'app_settings'

export interface AppSettings {
  vehiclesLimit?: number;
  driversLimit?: number;
  reportsLimit?: number;
  usersLimit?: number;
  warehouseLimit?: number;

}

export const getAppSettings = (): AppSettings => {
  try {
    const settingsStr = localStorage.getItem(SETTINGS_KEY)
    if (settingsStr) {
      return JSON.parse(settingsStr) as AppSettings
    }
  } catch {
    // Ignore error
  }
  return {}
}

export const updateAppSettings = (updates: Partial<AppSettings>): AppSettings => {
  try {
    const current = getAppSettings()
    const updated = { ...current, ...updates }
    localStorage.setItem(SETTINGS_KEY, JSON.stringify(updated))
    return updated
  } catch {
    // Ignore error
  }
  return {}
}
